import { cn } from "@/lib/cn";

/** PahFacturar wordmark. Emerald gradient + invoice-line glyph. */
export function Logo({
  compact,
  className,
}: {
  compact?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn("inline-flex items-center gap-2", className)}
      aria-label="PahFacturar"
    >
      <svg className="h-7 w-7" viewBox="0 0 32 32" aria-hidden="true">
        <defs>
          <linearGradient id="pahfacturar-logo-g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#10b981" />
            <stop offset="100%" stopColor="#047857" />
          </linearGradient>
        </defs>
        <path
          d="M16 2 L28 6 V16 C28 23 22 28 16 30 C10 28 4 23 4 16 V6 Z"
          fill="url(#pahfacturar-logo-g)"
        />
        <path
          d="M10 12 h12 M10 17 h8 M10 22 h10"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
      <span
        className={cn(
          "font-semibold tracking-tight text-[17px] text-foreground",
          compact && "hidden sm:inline",
        )}
      >
        Pah<span className="text-primary">Facturar</span>
      </span>
    </span>
  );
}
